import { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material";
import ChatbotCalendar from "../../../../../Assets/Icons/chatbot-calendar.svg";
import dayjs from "dayjs";

const dateFormat = "MMM D, YYYY";

const CustomDatePicker = styled(DatePicker)({
  width: "180px",

  "& .MuiInputLabel-root": {
    color: "rgba(100, 56, 67, 0.3)",

    "&.Mui-focused": {
      top: 0,
    },
  },

  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff1f2",
    borderRadius: "15px",

    "& .MuiOutlinedInput-input": {
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      height: "40px",
      padding: "0 14px",
      color: "#171717",
    },
  },
});

const CalendarIcon = () => (
  <img
    src={ChatbotCalendar}
    alt="calendar"
    style={{ width: "24px", height: "24px" }}
  />
);

const ChatbotDatePicker = ({ onSelect }) => {
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (date) => {
    setValue(date);
    const formattedDate = date?.format(dateFormat);
    onSelect(formattedDate);
  };

  return (
    <div className="chatbot-date-picker">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CustomDatePicker
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={value}
          format={dateFormat}
          inputFormat={dateFormat}
          minDate={dayjs(+new Date())}
          maxDate={dayjs().add(5, "years")}
          onAccept={handleChange}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            textField: {
              inputProps: {
                readOnly: true,
                placeholder: "Select a date",
                value: value?.format(dateFormat) || "",
              },
              onClick: handleOpen,
            },
          }}
          sx={{
            "& .MuiInputLabel-root": {
              top: !!value ? 0 : "-7px",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default ChatbotDatePicker;
